Array.from(document.getElementsByClassName("featured-collection-slider-component")).forEach(slider => {
  //Making the current page zero based for easier css calculation
  slider.addEventListener("slideChanged", (event) => event.target.style.setProperty('--current-page', event.detail.currentPage - 1));
});
